export default {
  Name: '名称：',
  Type: '类型：',
  KnowledgeBase: '知识库：',
  HitCount: '命中条数：',
  Context: '上下文：',
  ContextCount: '上下文数量：',
  Input: '输入：',
  Output: '输出：',
  SQLStatement: 'SQL语句：',
  ExecutionStatus: '执行状态：',
  BranchSelection: '分支选择：',
  Tokens: 'tokens：',
  Points: '积分：',
  Status: '状态：',
  Success: '成功',
  Failed: '失败',
  Question: '问题：',
  Answer: '答案：',
  NoNodes: '暂无选项',
}